import React from "react"

import { format } from "date-fns"
import { Clock, MapPin } from "lucide-react"

import { Card, CardContent } from "@/components/ui/card"

interface VehicleCollectionConfirmationSummaryProps {
  selectedDate: Date | undefined
  isTimeSelected: boolean
  depot?: {
    name: string
    address: string
    city: string
  }
}

const VehicleCollectionConfirmationSummary: React.FC<VehicleCollectionConfirmationSummaryProps> = ({
  selectedDate,
  isTimeSelected,
  depot,
}) => {
  if (!selectedDate || !isTimeSelected) {
    return null
  }

  return (
    <Card className="border-green-200 bg-green-50">
      <CardContent className="pt-6">
        <div className="flex items-start space-x-3">
          <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-green-100">
            <Clock className="h-4 w-4 text-green-600" />
          </div>
          <div className="space-y-2">
            <h3 className="font-semibold text-green-900">Your Vehicle Collection Confirmed</h3>
            <div className="grid grid-cols-1 gap-4 text-sm md:grid-cols-2">
              <div>
                <span className="font-medium text-green-800">Date & Time:</span>
                <p className="text-green-700">
                  {format(selectedDate, "EEEE, MMMM d, yyyy")} at {format(selectedDate, "h:mm a")}
                </p>
              </div>
              <div>
                <span className="flex items-center gap-1 font-medium text-green-800">
                  <MapPin className="h-3 w-3" />
                  Location:
                </span>
                <p className="text-green-700">
                  {depot
                    ? `${depot.name}, ${depot.address}, ${depot.city}`
                    : "HIVED Operations Center"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default VehicleCollectionConfirmationSummary
